"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isServerSideRendering_1 = __importDefault(require("./isServerSideRendering"));
/**
 * Sends the browser focus to the top (smoothly).
 * Safe to invoke on the server, however it won't do anything.
 */
function scrollWindowToTop() {
    if (!isServerSideRendering_1.default()) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}
exports.default = scrollWindowToTop;
//# sourceMappingURL=scrollWindowToTop.js.map